import React, { useEffect } from 'react';
import './ImageZoomModal.css';

const ImageZoomModal = ({ image, onClose }) => {
  useEffect(() => {
    if (!image) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [image, onClose]);

  if (!image) {
    return null;
  }

  const alt = image.alt || image.title || 'Product photo';

  return (
    <div className="image-zoom" role="dialog" aria-modal="true" aria-label={alt} onClick={onClose}>
      <div className="image-zoom__panel" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="image-zoom__close" onClick={onClose} aria-label="Close image preview">
          x
        </button>
        <img src={image.src} alt={alt} />
        {image.title && <div className="image-zoom__caption">{image.title}</div>}
      </div>
    </div>
  );
};

export default ImageZoomModal;
